import * as React from 'react';
import {useRoute} from 'react-router5';
import {LessonObject} from 'api/lesson/types';
import {getLessonByID} from 'api/lesson/requests';
import LessonViewer from 'components/LessonViewer';
import validateResponse from 'helpers/validate-response';
import isError from 'helpers/isError';
import {IconLoading} from 'icons';
import {Helmet} from 'react-helmet';

/**
 * The view lesson page
 * @constructor
 */
export default function ViewLesson(): React.ReactElement {
  const {route: {params}} = useRoute();

  const [
    lesson,
    setLesson,
  ] = React.useState<LessonObject | undefined>(undefined);

  React.useEffect(() => {
    getLessonByID(params.id).then((response) => {
      validateResponse(response);
      !isError(response) && (
        response && setLesson(response)
      );
    });
  }, []);

  return (
    <React.Fragment>
      <Helmet>
        <title>GrowPlace / Просмотр урока</title>
      </Helmet>
      {lesson ? (
        <LessonViewer {...lesson} />
      ) : <IconLoading />}
    </React.Fragment>
  );
}
